import Footer from '../global/components/Footer';
import Header from '../global/components/Header';
import ResolutionsContent from './components/ResolutionsContent';
import { ResolutionsProvider } from './contexts/ResolutionsContext';
import { AuthenticationProvider } from '../global/contexts/AuthenticationContext';

//This component sets up the Resolutions application by calling the Header,
//AuthenticationProvider, ResolutionProvider, ResolutionsContent, and Footer components.
export default function ResolutionsApp() {
    return (
        <>
            <Header message={"Resolution Feedback"} />
                <AuthenticationProvider>
                    <ResolutionsProvider >
					    <ResolutionsContent />
				    </ResolutionsProvider>
                </AuthenticationProvider>
            <Footer />
        </>
    );
}